import { render, staticRenderFns } from "./CreateOrUpdateClass.vue?vue&type=template&id=964a5bd4&scoped=true&"
import script from "./CreateOrUpdateClass.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a5bd4",
  null
  
)

export default component.exports